import { QueryClient } from "@tanstack/react-query";
import { queryKeys } from "./query-keys";

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 5 * 60 * 1000,
      retry: 1,
    },
  },
});

export const queryUtils = {
  auth: {
    invalidateAll: () =>
      queryClient.invalidateQueries({ queryKey: queryKeys.auth.all() }),
    invalidateUser: () =>
      queryClient.invalidateQueries({ queryKey: queryKeys.auth.user() }),
  },
  exams: {
    invalidateAll: () =>
      queryClient.invalidateQueries({ queryKey: queryKeys.exams.all() }),
    invalidateExam: (slug: string) =>
      queryClient.invalidateQueries({
        queryKey: queryKeys.exams.detail(slug),
      }),
    invalidateUserExams: () =>
      queryClient.invalidateQueries({
        queryKey: queryKeys.exams.userExams(),
      }),
  },
  sections: {
    invalidate(sectionId: number) {
      queryClient.invalidateQueries({
        queryKey: queryKeys.sections.section(sectionId),
      });
    },
  },
  studentGroups: {
    invalidateAll: () =>
      queryClient.invalidateQueries({
        queryKey: queryKeys.studentGroups.all(),
      }),
    invalidateMyGroups: () =>
      queryClient.invalidateQueries({
        queryKey: queryKeys.studentGroups.myGroups(),
      }),
  },
  examSharings: {
    invalidateAll: () =>
      queryClient.invalidateQueries({
        queryKey: queryKeys.examSharings.all(),
      }),
  },
  studentExamProgress: {
    invalidate(sectionId: number) {
      queryClient.invalidateQueries({
        queryKey: queryKeys.studentExamProgress.section(sectionId),
      });
    },
  },
  admin: {
    users: {
      invalidateAll: () =>
        queryClient.invalidateQueries({ queryKey: queryKeys.admin.all() }),
      invalidateAppUsers: (search: string) =>
        queryClient.invalidateQueries({
          queryKey: queryKeys.admin.appUsers(search),
        }),
    },
  },
  userConversations: {
    invalidateAll: () =>
      queryClient.invalidateQueries({
        queryKey: queryKeys.userConversations.all(),
      }),
  },
  cart: {
    invalidate: () =>
      queryClient.invalidateQueries({
        queryKey: queryKeys.cart.userCart(),
      }),
  },
  aiInterviews: {
    invalidateAll: () =>
      queryClient.invalidateQueries({ queryKey: queryKeys.aiInterviews.all() }),
  },
};
